import React, { ReactElement, useState } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import {
  StyledAnswer,
  StyledQuestionAnswerContainer,
  StyledQuestionLabel,
  StyledQuestionToggleContainer
} from './FaqItem.styles'
import DownCaretIcon from 'images/DownCaretIcon'

interface QuestionAnswerProps {
  question: string,
  answer: string
}

const FaqItem = ({ question, answer }: QuestionAnswerProps): ReactElement => {
  const [ visible, setVisible ] = useState(false);
  const parsedAnswer = documentToReactComponents(JSON.parse(answer));

  return (
    <StyledQuestionAnswerContainer>
      <StyledQuestionToggleContainer onClick={() => setVisible(!visible)}>
        <StyledQuestionLabel>{question}</StyledQuestionLabel>
        <DownCaretIcon inverted={visible} />
      </StyledQuestionToggleContainer>
      {
        visible &&
        <StyledAnswer>
          {parsedAnswer}
        </StyledAnswer>
      }
    </StyledQuestionAnswerContainer>
  );
};

export default FaqItem;
